export default "__VITE_ASSET__ac2902ad__"